import React, { useState } from "react";
import { useIntl } from "react-intl";
import { useAuth } from "src/app/utils/useAuth";
import { PageTitle } from "src/_metronic/layout/core";
import {
    SimpleEntityGrid,
    SimpleEntityGridColumn,
} from "../../../components/grid/SimpleEntityGrid";
import {
    AddBoostToOrderModelContainer,
    NetlinkingStepModalFormContainer,
    UpsertOrderFormBodyModalContainer,
} from "../../../containers";
import { OrderTransport } from "../../../transports/order";
import { UpsertOrderDTOSchema } from "../../../types/orders/order";
import useOnlineGridActions from "./useOnlineGridActions";
import IndexMeFormBodyContainer from "src/app/containers/IndexMeFormBody/IndexMeFormBodyContainer";
import SendTextOrderFormContainerWithChecked from "./SendTextOrderFormContainerWithChecked";
import useOnlineGridToolbarButtons from "./useOnlineGridToolbarButtons";
import { TSelectedRows } from "src/app/containers/AddBoostToOrderModel/AddBoostToOrderModelContainer";
import { toast } from "react-toastify";
import { OnlineOrder } from "src/app/types/orders/onlineOrderPage";

export interface IOnlineGrid {
    totalRowsHandle: (obj?: object) => Promise<number>;
    listHandler: (obj?: object) => Promise<number>;
    totalFilteredHandle: (obj?: object) => Promise<number>;
    exportHandler: (obj?: object) => Promise<number>;
    gridColumns: Array<SimpleEntityGridColumn>;
}
const OnlineGrid: React.FC<IOnlineGrid> = (props) => {
    const { totalRowsHandle, listHandler, totalFilteredHandle, exportHandler, gridColumns } = props;
    const { formatMessage } = useIntl();
    const { currentUser } = useAuth();

    const [showBoostModal, setShowBoostModel] = useState(false);
    const [selectedRows, setSelectedRows] = useState<Array<TSelectedRows> | null>(null);
    const [orderToUpdateGrid, setValueToUpdateGrid] = useState(false);

    const actions = useOnlineGridActions(currentUser);

    function handleAddBoostOrders(obj: any) {
        let data: Array<TSelectedRows> | null = null;
        obj.selectedRows.forEach((order: OnlineOrder) => {
            if (order.keywords && order.keywords?.length > 0 && order.url) {
                if (!data) data = [];
                data.push({
                    id: order.id,
                    keywords: order.keywords,
                    url: order.url,
                });
            }
        });
        setSelectedRows(data);

        if (!data) {
            toast.error(formatMessage({ id: "common.notification.error.allKeywords" }));
            return;
        }
        setShowBoostModel(true);
    }

    function handleClose() {
        setShowBoostModel(false);
    }

    function orderAsSendToUpdateGrid() {
        setValueToUpdateGrid(false);
    }

    function handlerValueToUpdateGrid(update: boolean) {
        setValueToUpdateGrid(update);
    }

    const toolbarButtonAction = useOnlineGridToolbarButtons(currentUser.role, handleAddBoostOrders);
    return (
        <>
            <PageTitle>{formatMessage({ id: "online.title" })}</PageTitle>
            <SimpleEntityGrid
                //GRID
                columns={gridColumns}
                listHandler={listHandler}
                rowModelType="serverSide"
                dataSourceLimit={500}
                totalRowsHandle={totalRowsHandle}
                totalFilteredHandle={totalFilteredHandle}
                exportHandler={exportHandler}
                //ACTIONS
                actions={actions}
                indexMeFormBodyContainer={IndexMeFormBodyContainer}
                sendTextFormBodyContainer={SendTextOrderFormContainerWithChecked}
                toggleActiveHandler={OrderTransport.toggleActive}
                //TOOLBAR
                toolbarButtonAction={toolbarButtonAction}
                orderAsSendToUpdateGrid={orderAsSendToUpdateGrid}
                NetlinkingFormBodyContainer={NetlinkingStepModalFormContainer}
                orderToUpdateGrid={orderToUpdateGrid}
                //EDIT
                entityName={formatMessage({ id: "common.entity.online" })}
                modalProps={{ size: "xl" }}
                UpsertFormBodyContainer={UpsertOrderFormBodyModalContainer}
                formBody={() => <></>}
                formTransformer={OrderTransport.formTransformer}
                validationSchema={UpsertOrderDTOSchema}
                saveHandler={OrderTransport.save}
            />
            {selectedRows && (
                <AddBoostToOrderModelContainer
                    selectedRows={selectedRows}
                    handlerValueToUpdateGrid={handlerValueToUpdateGrid}
                    handleClose={handleClose}
                    showModal={showBoostModal}
                />
            )}
        </>
    );
};

export default OnlineGrid;
